// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCuNojzF97CnDhq6aUPxRdGjrpGE9W_Uig',
  authDomain: 'carmarketplace-38bf7.firebaseapp.com',
  projectId: 'carmarketplace-38bf7',
  storageBucket: 'carmarketplace-38bf7.firebasestorage.app',
  messagingSenderId: '529567910024',
  appId: '1:529567910024:web:0bcbfbadab1d2571abf73d',
  measurementId: 'G-0VWSPRT9RW',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
